import "../../styles/Loader.scss";

const Loader = () => {
    return (
        <div className="loader_wrapper">
            <div className="loader" />
        </div>
    )
};

export default Loader;